import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  title: {
    fontSize: 20,
    marginTop: 16,
    marginBottom: 16,
    marginLeft: 0,
    marginRight: 0,
    fontWeight: 'bold',
    fontFamily: 'Roboto',
  },
  subtitle: {
    fontSize: 10,
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 0,
    marginRight: 0,
    fontWeight: 'bold',
    fontFamily: 'Roboto',
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    fontFamily: 'Roboto',
  },
  spaceBetweenVertical: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    fontFamily: 'Roboto',
  },
  addressContainer: {},
  deliveryNoteInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    fontFamily: 'Roboto',
    justifyContent: 'flex-end',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'Roboto',
  },
  deliveryNoteInfo: {
    marginVertical: 1,
    fontSize: 8,
    fontFamily: 'Roboto',
  },
  address: {
    margin: 1,
    fontSize: 8,
    fontFamily: 'Roboto',
  },
  body: {
    fontSize: 8,
    margin: 5,
    fontFamily: 'Roboto',
  },
  qrCode: {
    fontFamily: 'Roboto',
    height: 100,
    width: 100,
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    width: '100%',
    alignSelf: 'center',
    fontFamily: 'Roboto',
  },
});
